import React from "react";

interface ButtonProps {
  title: string;
  onClick?: () => void;
  inverted?: boolean;
}

export default function Button({
  title,
  onClick,
  inverted = false,
}: ButtonProps) {
  return (
    <div
      onClick={onClick}
      className={`${
        inverted
          ? "bg-white text-black border border-black"
          : "bg-black text-white"
      } px-5 py-2 rounded-lg cursor-pointer max-w-fit  max-h-fit
      hover:bg-gray-600
      `}
    >
      {title}
    </div>
  );
}
